import { html as t, ref as e } from "@microsoft/fast-element";
import { textAreaTemplate as a } from "@matrix42/fast-foundation";
const i = t`
  ${a()}
  <div class="hint" part="hint">
    <slot name="hint" ${e("hint")}></slot>
  </div>
`;
export {
  i as textAreaTemplate
};
